// Copyright The Linux Foundation and each contributor to LFX.
// SPDX-License-Identifier: MIT
import { Directive, ElementRef, HostListener, Input, OnInit, ViewContainerRef, TemplateRef, AfterViewInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { LoggedUserFacadeService } from '../state/logged-user/logged-user.facade';
import { LoggedUserResponse, UserRole } from '../state/logged-user';
import { LoggedUserService } from '../services/logged-user.service';

@Directive({
    // tslint:disable-next-line:directive-selector
    selector: '[allowedRoles]'
})
export class AllowedRolesDirective implements AfterViewInit {

    @Input() allowedRoles: string[] = [];
    @Input() allowedRolesElse: any;

    constructor(
        private vc: ViewContainerRef,
        private tpl: TemplateRef<any>,
        private loggedUserService: LoggedUserService,
        ) {}

    ngAfterViewInit(): void {
        if (this.loggedUserService.areRolesAllowed(this.allowedRoles)) {
            this.vc.createEmbeddedView(this.tpl);
        } else if (this.allowedRolesElse) {
            this.vc.createEmbeddedView(this.allowedRolesElse);
        }
    }

}



// WEBPACK FOOTER //
// ./src/app/core/directives/allowed-roles.directive.ts